/** 原生 WebSocket `/ws/live-feed` 信封；与服务端 `{ event, data }` 对齐 */

export type LiveFeedClientEvent = 'auth'
export type LiveFeedServerEvent = 'auth:ok' | 'big_win:batch'

export const LIVE_FEED_PATH = '/ws/live-feed'

export interface LiveFeedEnvelope<T = unknown> {
  event: string
  data: T
}

export interface LiveFeedAuthPayload {
  token: string
}

/** 首包不是 auth、JWT 无效、跨租户或会话已失效 */
export const LIVE_FEED_CLOSE_UNAUTHORIZED = 4401
/** 连接后 5 秒内未完成首包认证 */
export const LIVE_FEED_CLOSE_AUTH_TIMEOUT = 4408

export const LIVE_FEED_AUTH_FAIL_CODES: ReadonlySet<number> = new Set([
  LIVE_FEED_CLOSE_UNAUTHORIZED,
  LIVE_FEED_CLOSE_AUTH_TIMEOUT,
])
